export type Product = {
  name: string
  sku: string
  price: number
  availability: string
  image: string
  alt: string
}

/** Detail template route used by every sample product in this mockup. */
export const productDetailRoute = '/shop/product/viking-spas-replacement-filter'

/** Featured products from the Pegasus online catalog. */
export const featuredProducts: Product[] = [
  {
    name: 'Viking Spas replacement filter',
    sku: '14294',
    price: 56.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/6ch940.jpg400x400.jpg',
    alt: 'Viking Spas replacement spa filter cartridge',
  },
  {
    name: "12649 2013-02/2023 680 Series Sundance Spas 50 sq' Filter",
    sku: '12649',
    price: 52.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c4950.jpg400x400.jpg',
    alt: "Sundance Spas 680 Series 50 square foot replacement filter cartridge",
  },
  {
    name: "Sundance Spa Filter 125 sq'",
    sku: '12627',
    price: 115.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c8325.jpg400x400.jpg',
    alt: "Sundance Spas 125 square foot replacement filter cartridge",
  },
  {
    name: 'Cover Conditioner',
    sku: '12706',
    price: 8.95,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/shampoo.png',
    alt: 'Bottle of spa cover conditioner',
  },
  {
    name: 'Spa & Pool Vacuum',
    sku: '16825',
    price: 75.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/130065.jpg',
    alt: 'Handheld spa and pool vacuum',
  },
  {
    name: 'Chlorine Test Strip 4 in 1',
    sku: '12533',
    price: 16.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/chlorine.jpg400x400.jpg',
    alt: 'Bottle of 4-in-1 chlorine test strips',
  },
  {
    name: 'Bamboo Grill Skewers',
    sku: '11070',
    price: 2.49,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/41hXbkXtn5L.jpg400x400.jpg',
    alt: 'Package of bamboo grill skewers',
  },
  {
    name: '20# Lump Charcoal',
    sku: '13694',
    price: 24.95,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Big%20Green%20Egg/Charcoal.jpg400x400.jpg',
    alt: '20 pound bag of natural lump charcoal',
  },
]

/** Related replacement filters shown on the product-detail template. */
export const relatedFilters: Product[] = [
  {
    name: "12649 2013-02/2023 680 Series Sundance Spas 50 sq' Filter",
    sku: '12649',
    price: 52.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c4950.jpg400x400.jpg',
    alt: 'Sundance Spas 680 Series 50 square foot replacement filter cartridge',
  },
  {
    name: "Sundance Spa Filter 125 sq'",
    sku: '12627',
    price: 115.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c8325.jpg400x400.jpg',
    alt: 'Sundance Spas 125 square foot replacement filter cartridge',
  },
  {
    name: "12628 1 Piece 780 Series Micro Clean Sundance Spa Filter 125Sq'",
    sku: '12628',
    price: 117.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Filters/c8326.jpg400x400.jpg',
    alt: 'Sundance Spas 780 Series Micro Clean 125 square foot replacement filter cartridge',
  },
]

export function formatPrice(price: number): string {
  return `$${price.toFixed(2)}`
}
